import { createFileRoute, useParams, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { TagsManagementPage } from '../../../../components/tags/TagsManagementPage'

const tagDetailSearchSchema = z.object({
    type: z.enum(['all', 'asset', 'document', 'user', 'contract', 'issue', 'expense', 'conversation']).optional(),
    q: z.string().optional(),
    page: z.number().optional(),
})

export const Route = createFileRoute('/$org/settings/tags/$tagId')({
    validateSearch: tagDetailSearchSchema,
    component: SettingsTagDetailPage,
})

function SettingsTagDetailPage() {
    const { org, tagId } = useParams({ from: '/$org/settings/tags/$tagId' })
    const search = useSearch({ from: '/$org/settings/tags/$tagId' })
    return <TagsManagementPage org={org} tagId={tagId} search={search} />
}
